import defaultStates from '../../src-component/defaultStates';


export const apiHome = 'https://api.camscon.kr/v1';
// export const apiHome = 'http://localhost:8000/v1';

// lcg 참고로, 무조건 이게적용된다. localStorageKey = 'camscon-production';
export function isLogon() {
    return defaultStates.isLogon();
}


//2016.01.01 17:56:57 ===> (7분전)
//~분전 / ~시간전 / ~7일전 / 20160101
export default function getNaturalTimeString(theTime = '2012-06-05 11:23:30') {
    var naturalTimeString = "";
    theTime = '' + theTime;

    //년월일시간분초형식
    var sYear = theTime.substring(0, 4);
    var sMonth = theTime.substring(5, 7) - 1;
    var sDate = theTime.substring(8, 10);
    var sHour = theTime.substring(11, 13);
    var sMin = theTime.substring(14, 16);
    var sSecond = theTime.substring(17, 19);

    var thisDateTime = new Date();
    var theDateTime = new Date(sYear, sMonth, sDate, sHour, sMin, sSecond);

    //지나간 초 현재와의 간격
    var pastSecond = parseInt((thisDateTime - theDateTime) / 1000, 10);
    if (pastSecond > 86400 * 365) {
        naturalTimeString = parseInt(pastSecond / 86400 / 365, 10) + "년 전";
    } else if (pastSecond > 86400 * 30) {
        naturalTimeString = parseInt(pastSecond / 86400 / 30, 10) + "달 전";
    } else if (pastSecond > 86400 * 7) {
        naturalTimeString = parseInt(pastSecond / 86400 / 7, 10) + "주 전";
    } else if (pastSecond > 86400) {
        naturalTimeString = parseInt(pastSecond / 86400, 10) + "일 전";
    } else if (pastSecond > 3600) {//~시간전
        naturalTimeString = parseInt(pastSecond / 3600, 10) + "시간 전";
    } else if (pastSecond > 60) {
        naturalTimeString = parseInt(pastSecond / 60, 10) + "분 전";
    } else if (pastSecond >= 0) {
        naturalTimeString = pastSecond + "초 전";
    } else { naturalTimeString = "방금" };
    return naturalTimeString;
}

// lcg 막입력한거로부터, 해시태그문자열 얻기
function obtainHashtagString(v) {
    var resultString = "";
    resultString = v.split(' ').join('');
    resultString = resultString.split(/[,]+/).join(',');

    resultString = resultString.split(',').join(' #');

    if (!resultString.startsWith(' #')) resultString = ' #' + resultString;
    if (resultString.endsWith(' #')) resultString = resultString.substring(0, resultString.length - 2);

    resultString = resultString.trim()+' ';
    return resultString;
}
export {
    getNaturalTimeString
    ,obtainHashtagString
    ,window_open_pt
}

function window_open_pt(url, popupID){
    if (typeof window.ptDetail != 'undefined') window.ptDetail.close();
    var width = 1290; // 1. 최초사이즈
    var height = 965;
    width = 900; // 2. 줄인 사이즈
    height = width*.625+50; // 1. 최초비율

    width = 1050; // 3. 0411. 늘인 사이즈
    height = 720; // 3. 0411. 비율폐기, 높이를 좀더 여유있게해보자.


    window.ptDetail = window.open(url, popupID, "scrollbars=no,width="+width+",height="+height);
}


// import { ajaxor } from '../../../common/basic';

// ajaxor({
//     url: "/inspiration/feed?limit=30&page=" + parseInt(vThisList.length / 30 + 1),
//     callback: r => setThisList(vThisList.concat(r.data))
// });

// 응답 원본 받기.
export const ajaxor0 = p => {
    var absoluteURL = p.url.startsWith(apiHome) ? '' : apiHome;

    var settings = {
        headers: {
            'Client-Type': 'webapp',
            'Access-Control-Allow-Origin': document.location.host,
            "Authorization": "Bearer " + localStorage[defaultStates.localStorageKey],
        },
    };

    Object.keys(p).forEach(k => settings[k] = p[k]);
    settings.url = absoluteURL + p.url;
    // console.log("settings: ", settings);
    $.ajax(settings).done(function (r) {
        !p.callback ? null : p.callback(r);
    });
}

// GET, 응답 데이터만 받기
export const ajaxor2 = p => {
    var absoluteURL = p.url.startsWith(apiHome) ? '' : apiHome;

    var settings = {
        headers: {
            'Client-Type': 'webapp',
            'Access-Control-Allow-Origin': document.location.host,
            "Access-Control-Allow-Origin":"*",
            "Authorization": "Bearer " + localStorage[defaultStates.localStorageKey],
        },
    };

    Object.keys(p).forEach(k => settings[k] = p[k]);
    settings.url = absoluteURL + p.url;

    // console.log("settings: ",settings);
    $.ajax(settings).done(function (r) {
        !p.callback ? null : p.callback(r.data);
    }).fail(function (r) {
        console.log("fail: ",r);
    });
}


// GET, 응답 데이터만 받기 (Access-Control-Allow-Origin 뺀거)
export const ajaxor22 = p => {
    var absoluteURL = p.url.startsWith(apiHome) ? '' : apiHome;

    var settings = {
        headers: {
            'Client-Type': 'webapp',
            "Authorization": "Bearer " + localStorage[defaultStates.localStorageKey],
        },
    };

    Object.keys(p).forEach(k => settings[k] = p[k]);
    settings.url = absoluteURL + p.url;

    // console.log("settings: ",settings);
    $.ajax(settings).done(function (r) {
        !p.callback ? null : p.callback(r.data);
    });
}


// 포스트 전용, x-www-formed바디로 보내기 이걸로 쓰자. 기존꺼랑 맞다.
export const ajaxor4 = p => {
    var absoluteURL = p.url.startsWith(apiHome) ? '' : apiHome;

    var settings = {
        headers: {
            'Client-Type': 'webapp',
            'Access-Control-Allow-Origin': document.location.host,
            "Authorization": "Bearer " + localStorage[defaultStates.localStorageKey],
        },
        type: 'post',
    };

    Object.keys(p).forEach(k => settings[k] = p[k]);
    settings.url = absoluteURL + p.url;

    // console.log("settings: ", settings);
    $.ajax(settings).done(function (r) {
        !p.callback ? null : p.callback(r.data);
    });
}

